




































import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import BaseComponent from '@/components/base-component.vue';
import ClientesResumeProducts from '@/components/prescription/resume/clientes-resume.vue';
import PrescriptionGeneralResume from '@/components/prescription/resume/general-resume.vue';
import PrescriptionValidationMessages from '@/components/prescription/validation-messages.vue';
import PrescriptionTemplateModel from '@/models/prescription-template-model';
import * as service from '@/services/client-unit';

@Component({
  components: {
    PrescriptionGeneralResume,
    PrescriptionValidationMessages,
    ClientesResumeProducts,
  },
})
export default class TemplateFormBase extends BaseComponent {
  @Prop()
  public item: PrescriptionTemplateModel;
  @Prop()
  public prescriptionState: any;
  @Prop()
  public validationMessages: any[];
  @Prop()
  public validationMessagesLoading: boolean;
  @Prop()
  public validationMessagesError: boolean;
  @Prop()
  public validationMessagesFirstTime: boolean;

  public openResumeSection: boolean = false;
  public isAlertModalOpen: boolean = false;
  public unitsClients: any[] = [];

  public beforeMount(): void {
    this.getClientsUnits();
  }

  // @Watch('item.unidadesCliente')
  // public onChangeData(val: any): void {
  //    if(val.length === 0)
  //     this.setPrescriptionState(PrescriptionValidation.INVALID.key);
  // }

  // @Watch('prescriptionState')
  // public onChangeStatePrescription(val: any): void {
  //    if(val === PrescriptionValidation.OK.key && this.item.unidadesCliente.length === 0)
  //     this.setPrescriptionState(PrescriptionValidation.INVALID.key);
  // }

  private getClientsUnits(): any {
    service.getClientUnits({ ativo: true }).subscribe(
      (data) => {
        this.unitsClients = data.map((unidade) => {
              {
                return {
                   id: unidade.id,
                   nome: unidade.nome,
                   empresa: unidade.empresa,
                   cliente: { nome: unidade.cliente.nome, id: unidade.cliente.id }
                };
              }
          });

      },
      () => {
        this.toast.show('Ocorreu um erro ao carregar os clientes', 'error');
      },
    );
  }

  public toggleResumeSection(): void {
    this.openResumeSection = !this.openResumeSection;
  }

  public onClickShowErrorProducts(val): void {
    this.$emit('clickShowErrorProducts', val);
  }

  public onClickFocusErrorProduct(val): void {
    this.$emit('clickFocusErrorProduct', val);
    this.isAlertModalOpen = false;
  }

  private setPrescriptionState(state: string): void {
    this.prescriptionState = state;
  }
}
